import { render, staticRenderFns } from "./errors-modal.vue?vue&type=template&id=8c3c1868&scoped=true"
import script from "./errors-modal.vue?vue&type=script&lang=js"
export * from "./errors-modal.vue?vue&type=script&lang=js"
import style0 from "./errors-modal.vue?vue&type=style&index=0&id=8c3c1868&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3c1868",
  null
  
)

export default component.exports